module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M8 26.666L2.666 32H0v-2.666l5.44-4.774L25.184 6.676c.818-.742.738-.848-.182-.234L3.042 21.834c-.562-.714-.806-1.938-.698-2.694C3.188 13.25 25.468 0 30 0c0 0 2 0 2 2 0 4.418-15.584 26-20 26-1.698 0-2.708-.43-4-1.334z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/feather-1.js
// module id = 1144
// module chunks = 14